import { Component, ViewEncapsulation } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { InterviewsService } from "./services/interviews.service";
import { ErrorHandlerService } from "src/app/services/error-handler.service";

@Component({
    selector: 'interviews',
    templateUrl: './interviews.page.html',
    //styleUrls: ['./referee.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InterviewsPage {
  constructor(
    private httpService: HttpService,
    private interviewsService: InterviewsService,
    private errorHandler: ErrorHandlerService
  ) {
    httpService.getAllMeetingsForCandidate().subscribe({
      next: result => {
        this.interviewsService.setMeetings(result.meetings);
      },
      error: err => {
        this.errorHandler.handleError(err);
      }
    })

    httpService.getInterviewDashboardInfo().subscribe({
      next: result => {
        this.interviewsService.setDashboardInfo(result);
      },
      error: err => {
        errorHandler.handleError(err);
      }
    });
  }
}
